// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'product.page.title.stock-taking': 'Stock Taking',
    'product.page.title': 'Products',
    'product-csv.page.import.title': 'Import Products',
    'product.page.search_results': 'Search Results',
    'product.page.create.title': 'Create New Product',
    'product.page.search.title': 'Find Products',
    'product.page.edit.title': 'Edit Product',
    'product.page.all': 'All',

    'product.button.cancel': 'Cancel',
    'product.button.select': 'Select',
    'product.button.find': 'Find Products',
    'product.button.search': 'Apply',
    'product.button.create': 'Save Product',
    'product.button.new': 'New Product',
    'product-csv.button.import': 'Import',
    'product.button.save': 'Save Changes',
    'product.button.delete': 'Permanently Delete',
    'product.button.edit': 'Edit',
    'product.button.restore': 'Restore',
    'product.button.reset': 'Reset',

    'product.placeholder.search': 'Search products',

    'product.link.create_first_product': 'Click here to create your first product',
    'product.link.products': ' Return to Products',
    'product.link.retry': 'Click here to retry',

    'product.checkbox.all': 'Check All',
    'product.checkbox.actions_label': 'with selected',

    'product.label.inventory_category_name': 'Category',
    'product.label.inventory_manufacturer_name': 'Manufacturer',
    'product.label.reporting_segment_name': 'Reporting Segment',
    'product.label.inventory_type_name': 'Type',
    'product.label.is_manufactured': 'Is Manufactured',
    'product.label.is_combinable': 'Is Combinable',
    'product.label.combinable_parent_inventory_name': 'Combinable Parent Product',
    'product.label.breakdown_pieces': 'Breakdown Pieces',
    'product.label.income_general_ledger_account_name': 'Income General Ledger Account',
    'product.label.cost_of_good_sold_general_ledger_account_name': 'Cost Of Good Sold General Ledger Account',
    'product.label.asset_general_ledger_account_name': 'Asset General Ledger Account',
    'product.label.tax_name': 'Tax',
    'product.label.item_number': 'Item Number',
    'product.label.barcode': 'Barcode',
    'product.label.item_name': 'Item',
    'product.label.item_description': 'Item Description',
    'product.label.currency_name': 'Currency',
    'product.label.is_fixed_price': 'Is Fixed Price',
    'product.label.current_units_on_hand': 'Current Units On Hand',
    'product.label.inventory_adjustment_type_id': 'Adjustment Type',
    'product.label.adjustment_general_ledger_account_id': 'Account',
    'product.label.adjustment_reason': 'Reason',
    'product.label.notes': 'Notes',
    'product.label.units': 'unit|units',
    'product.label.date_adjusted': 'Date Adjusted',
    'product.label.invalid_inventory': 'Units cannot exceed the current inventory',

    'product.label.unit_of_measure': 'Unit of Measure',
    'product.label.selling_price_in_cents': 'Selling Price',
    'product.label.reorder_level': 'Reorder Level',
    'product.label.units_on_hand': 'Units On Hand',
    'product.label.counted_warehouse': 'Counting stock in',

    'product.label.item_photo': 'Item Photo',
    'product.label.item_photo_size': 'Item Photo Size',
    'product.label.item_photo_mime_type': 'Item Photo Mime Type',

    'product.label.created_at': 'Created At',
    'product.label.updated_at': 'Updated At',
    'product.label.deleted_at': 'Deleted At',

    'product.label.product_attributes': 'Product Attributes',
    'product.label.additional_taxes': 'Additional Taxes',
    'product.label.status': 'Status',

    'product.sort.field_label': 'Field',
    'product.sort.direction_label': 'Direction',
    'product.sort.direction_ascending': 'Ascending',
    'product.sort.direction_descending': 'Descending',

    'product.modal.title.product_delete_permanently': 'Delete Product',
    'product.modal.title.product_restore': 'Restore Product',

    'product.modal.message.product_delete_permanently':
        'Are you sure that you want to permanently delete this product? This action cannot be undone. | Are you sure that you want to permanently delete these products? This action cannot be undone.',
    'product.modal.message.product_restore': 'Are you sure that you want to restore this product? | Are you sure that you want to restore these products?',

    'product.success.message.product_created': 'Your product has been created',
    'product.success.message.product_updated': 'Your product has been updated',
    'product.success.message.product_restored': 'Your product has been restored | All selected products were restored',
    'product.success.message.product_deleted': 'Your product has been permanently deleted | All selected products were permanently deleted',

    'product.error.message.product_deleted': 'This product was already permanently deleted | These products were already permanently deleted',
    'product.error.message.product_restored': 'This product was already restored | These products were already restored',
    'product.error.message.error_loading_page': 'Sorry, there was an error loading product.| Sorry, there was an error loading products.',
    'product-csv.error.message.csv_is_blank': "It looks like the CSV file is empty. No worries — just take a moment to double-check your file, and feel free to try again whenever you're ready!",
    'product-csv.error.message.invalid_file_type': 'Sorry, we only support CSV files. Please try again with a CSV file.',

    'product-csv.page.note': 'Please ensure to click the check mark if your file already includes headers.',
    'product-csv.label.opening_stock_date': 'Opening stock date',
    'product-csv.help.opening_stock_date': 'The date your opening stock is recorded as on hand. Defaults to today.',
    'product-csv.label.stock_in_opening_balances': 'Is this stock value already in your opening balances?',
    'product-csv.option.stock_in_opening_balances.yes': 'Yes — I imported a trial balance that already includes this inventory value',
    'product-csv.option.stock_in_opening_balances.no': 'No — this is a brand-new set-up with no opening balances',
    'product-csv.help.stock_in_opening_balances':
        'If your imported trial balance already accounts for this inventory, we record the quantities only — so the inventory value is not counted twice. Otherwise we post the opening stock to your general ledger.',
    'product-csv.error.message.too_many_rows': 'You can import at most {max} products at a time. Please split your file into smaller batches.',
    'product.success.message.products_imported': 'Please check your email for the import status.',
    'product-csv.page.instructions': 'Below are two sample files which will show the fields used in the import process.',

    'product-csv.page.required_fields': 'Required Fields',
    'product-csv.page.all_fields': 'All Fields',
    'product-import.button.download': 'Download sample file',

    'product-csv.page.message.column_names': 'Column names are in the first line',
    'product-csv.page.message.field': 'Field',
    'product-csv.page.message.column': 'Column',

    'product.page.archive.title': 'Archived Products',
    'product.button.archive': 'Archive',

    'product.link.archive': 'Archived Products',

    'product.modal.title.product_archive': 'Archive Product',

    'product.modal.message.product_archive': 'Are you sure that you want to move this product to the archive? | Are you sure that you want to move these products to the archive?',

    'product.success.message.archived_products': 'Your product was moved to the archive | All selected products were moved to the archive',

    'product.error.message.archived_products': 'This product was already moved to the archive | These products were already moved to the archive',

    'product.error.message.archive_bom_member':
        '{product} is part of bill of materials {boms}. Archive those bills of materials, or remove {product} from them, before archiving it.',

    'product.error.message.archive_holds_stock':
        '{product} still holds {units} units of stock. Transfer the stock out, or write it off, before archiving it.',

    'product.error.message.archive_live_holds':
        '{product} has {held} units reserved for sales order(s) {orders}. Release the reservations before archiving it.',

    'product.error.message.archive_stock_and_holds':
        '{product} still holds {units} units of stock, with {held} units reserved for sales order(s) {orders}. Clear the stock and release the reservations before archiving it.',

    'product.message.search.no_archived_products': "You don't have any archived products.",
};
